import { render } from "./UaQcResults.vue?vue&type=template&id=6437298c&scoped=true"
import script from "./UaQcResults.vue?vue&type=script&lang=js"
export * from "./UaQcResults.vue?vue&type=script&lang=js"

import "./UaQcResults.vue?vue&type=style&index=0&id=6437298c&lang=scss&scoped=true"
import "./UaQcResults.vue?vue&type=style&index=1&id=6437298c&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6437298c"],['__file',"src/components/cases/UaQcResults.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6437298c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6437298c', __exports__)) {
    console.log('reload')
    api.reload('6437298c', __exports__)
  }
  
  module.hot.accept("./UaQcResults.vue?vue&type=template&id=6437298c&scoped=true", () => {
    console.log('re-render')
    api.rerender('6437298c', render)
  })

}


export default __exports__